import React from "react";
import { styled } from "@mui/material/styles";
import PropTypes from "prop-types";
import LinearProgress from "@mui/material/LinearProgress";

const StyledLinearProgress = styled(LinearProgress)({
  position: "absolute",
  height: "5px",
  bottom: 0,
  left: 0,
  width: "100%",
  borderRadius: "0 0 4px 4px",
});

const normalize = (value, max, min = 0) => ((value - min) * 100) / (max - min);

const VIDEO = "VIDEO";
const BOOK = "BOOK";

export default function ThumbnailProgress({ content }) {
  // Handle video progress
  if (content.type === VIDEO) {
    if (!content.viewerVideoPosition || !content.duration) return null;

    return (
      <StyledLinearProgress
        variant="determinate"
        value={normalize(content.viewerVideoPosition, content.duration)}
      />
    );
  }

  // Handle book progress
  if (content.type === BOOK) {
    const progressPercent = content.bookMetadata?.userBook?.progressPercent;
    if (!progressPercent || progressPercent <= 0) return null;

    return (
      <StyledLinearProgress variant="determinate" value={progressPercent} />
    );
  }

  return null;
}

ThumbnailProgress.propTypes = {
  content: PropTypes.shape({
    type: PropTypes.string.isRequired,
    viewerVideoPosition: PropTypes.number,
    duration: PropTypes.number,
    bookMetadata: PropTypes.shape({
      userBook: PropTypes.shape({
        progressPercent: PropTypes.number,
      }),
    }),
  }),
};
